import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../../commonFields";

export const internalSearchResultsBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Internal Search Results",
  description:
    "Displays search results with pagination. Must be placed inside Internal Search Wrapper on SWDC or in CSC Internal Search Context on CSC pages.",
  noWrap: false,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
    builderLinkComponent: true,
  },
  canHaveChildren: false,
  defaults: {
    responsiveStyles: {
      large: {
        maxWidth: "792px",
        minWidth: "0",
        flexShrink: "1",
      },
      medium: {
        width: "100%",
        minWidth: "0",
      },
    },
  },
  inputs: [
    {
      name: "variant",
      type: "enum",
      enum: ["swdc", "support"],
      required: true,
      defaultValue: "swdc",
    },
    {
      name: "resultsText",
      type: "string",
      localized: true,
      defaultValue: "Showing {count} results",
      helperText: "Use {count} placeholder",
    },
    {
      name: "loadingText",
      type: "string",
      localized: true,
      defaultValue: "Retrieving resources",
    },
    {
      name: "noResultsTitle",
      type: "string",
      localized: true,
      defaultValue: 'Sorry, We couldn\'t find any matches for "{searchValue}"',
    },
    {
      name: "noResultsSuggestion",
      type: "richText",
      localized: true,
      defaultValue:
        "<p>Search tips:</p><ul><li>Check Spelling</li><li>Try rephrasing your search query or adjusting your filters</li></ul>",
    },
    {
      name: "previousCTAText",
      type: "string",
      localized: true,
      defaultValue: "Previous",
    },
    {
      ...DLT_FIELD,
      name: "previousCTADLT",
      friendlyName: "Previous CTA DLT",
      defaultValue: "Internal Search",
    },
    {
      ...DLD_FIELD,
      name: "previousCTADLD",
      friendlyName: "Previous CTA DLD",
      defaultValue: "Previous CTA",
    },
    {
      name: "nextCTAText",
      type: "string",
      localized: true,
      defaultValue: "Next",
    },
    {
      ...DLT_FIELD,
      name: "nextCTADLT",
      friendlyName: "Next CTA DLT",
      defaultValue: "Internal Search",
    },
    {
      ...DLD_FIELD,
      name: "nextCTADLD",
      friendlyName: "Next CTA DLD",
      defaultValue: "Next CTA",
    },
  ],
};
